import { system } from '@workday/canvas-tokens-web'

const baseStyle = ({ theme }) => ({
  overlay: {
    bgColor: theme.isSanaRebrand ? `var(${system.color.surface.overlay.scrim})` : 'rgba(0, 0, 0, 0.3)'
  },
  dialog: {
    borderRadius: theme.isSanaRebrand ? 'xxxl' : 'base',
    boxShadow: theme.isSanaRebrand ? '6' : '0px 8px 16px 0px rgba(0, 0, 0, 0.32)',
    minH: '200px',
    ...(theme.isSanaRebrand
      ? {
          '--vndly-modal-header-pl': 'var(--chakra-space-6)',
          // Back button and title share the first row so a long (translated) label pushes the title over.
          '&:has(> [data-modal-back-button])': {
            '--vndly-modal-header-pl': 'var(--chakra-space-3)',
            display: 'grid',
            gridTemplateColumns: 'fit-content(40%) minmax(0, 1fr)',
            gridTemplateRows: 'auto minmax(0, 1fr)',
            '& > :not([data-modal-back-button], .chakra-modal__header, .chakra-modal__close-btn)': {
              gridColumn: '1 / -1'
            }
          }
        }
      : {})
  },
  body: theme.isSanaRebrand
    ? {
        '--vndly-modal-body-pb': 'var(--chakra-space-6)',
        '&:has(~ .chakra-modal__footer)': { '--vndly-modal-body-pb': '0px' }
      }
    : {},
  footer: {
    borderColor: `var(${system.color.border.strong})`
  },
  closeButton: {
    ...(theme.isSanaRebrand ? { borderRadius: 'full', w: '40px', h: '40px' } : {}),
    _focusVisible: {
      boxShadow: 'middleOutline'
    }
  }
})

/**
 * A modal that is basically "full" sized but max width is limited to the largest breakpoint,
 * just like how our Container component works. Also includes 16px margin around the outer edge
 * so modal does not touch the viewport screen edges.
 */
function sizeContainer(props) {
  return {
    dialog: {
      my: 0,
      w: 'calc(100vw - 16px * 2)',
      maxW: props.theme.breakpoints.xl,
      h: 'calc(100vh - 16px * 2)',
      position: 'fixed',
      left: 'auto',
      top: 4
    },
    footer: {
      justifyContent: 'flex-start',
      borderTopWidth: props.theme.isSanaRebrand ? 0 : '1px',
      borderColor: `var(${system.color.border.strong})`
    }
  }
}

const sizes = {
  container: sizeContainer
}

export const Modal = {
  baseStyle,
  sizes
}
